import React from 'react';
import PropTypes from 'prop-types';
import _ from 'underscore';
import { DropdownSelector } from '@bingads-webui-react/dropdown-selector';

export class MetricsPicker extends React.PureComponent {
  renderSelectedItem = (item) => {
    // Format the selected item content based on whether comparison data is being shown.
    const selectedItemDataDisplayClass = this.props.isPopOrMovingAvg ? 'show-selectedItem-percentage' : 'hide-selectedItem-percentage';

    return (
      <div>
        <div className="selectedItem-data">{item.value}</div>
        <div className={selectedItemDataDisplayClass}>{this.props.selectedItemPercentage}</div>
      </div>
    );
  }

  render() {
    const comparisonMetricDisplayClass = this.props.isPopOrMovingAvg ? 'show-comparison-line' : 'hide-comparison-line';
    const selectedItem = _.findWhere(this.props.allMetrics, { id: this.props.selectedItem.id });

    const metricPickerAriaLabel = this.props.class === 'secondary-metric'
      ? this.props.i18n.getString('BI_Chart_SecondaryMetricPicker')
      : this.props.i18n.getString('BI_Chart_MetricPicker');

    return (
      <div className={this.props.class} >
        <div className="metric-colors">
          <span className="metric-color metric-color-line" />
          <span className={`comparison-color metric-color-line ${comparisonMetricDisplayClass}`} />
        </div>
        <DropdownSelector
          selectedItem={selectedItem}
          onSelect={this.props.onChangeHandler}
          totalCount={(this.props.allMetrics).length}
          items={this.props.allMetrics}
          renderSelectedItem={this.renderSelectedItem}
          renderItem={item => (
            <li className="list-selector-option" role="presentation">
              {item.isFluctuation ?
                (
                  <div>
                    <span className="inline-recommendation-grid-icon" />
                    <span className="inline-chart-option">{item.value}</span>
                  </div>
                  ) :
                (<span>{item.value}</span>)}
            </li>
          )}
          i18n={this.props.i18n}
          dropdownMenuAriaLabel={metricPickerAriaLabel}
          enableArrowKeysSupport
          shouldFocusFirstFocusableItemOnMount
        />
      </div>
    );
  }
}

MetricsPicker.propTypes = {
  allMetrics: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number.isRequired,
    value: PropTypes.string.isRequired,
  })).isRequired,
  onChangeHandler: PropTypes.func.isRequired,
  selectedItem: PropTypes.shape({
    id: PropTypes.number.isRequired,
    value: PropTypes.string.isRequired,
  }).isRequired,
  isPopOrMovingAvg: PropTypes.bool,
  selectedItemPercentage: PropTypes.string,
  class: PropTypes.string,
  /**
   * i18n for localization
   */
  i18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
    parseDecimal: PropTypes.func.isRequired,
  }).isRequired,
};

MetricsPicker.defaultProps = {
  isPopOrMovingAvg: false,
  selectedItemPercentage: '',
  class: 'metrics-picker',
};
